export default function () {
    return {
        isActive: null,
        items: [],
        init() {
            if (!this.isMobile()) {
                this.getData();
                this.setupObserver();
            }
        },
        getData() {
            const charactersToRemove = ['(0)', ':', '!'];
            const sections = document.querySelectorAll('.anchor-section');
            let i = 1;

            for (const section of sections) {
                if (section.children.length > 0) {
                    const heading = section.querySelector('.h2-anchor');
                    const sectionText = charactersToRemove.reduce(
                        (str, char) => {
                            return str.split(char).join('');
                        },
                        heading.textContent
                    );
                    if (i === 1) {
                        this.isActive = `#${section.id}`;
                    }

                    this.items.push({
                        text: sectionText,
                        link: `#${section.id}`
                    });
                    i++;
                }
            }
        },
        renderClass() {
            return `item-${this.items.length}`;
        },

        smoothAnchor(item) {
            const offset = 80;
            const element = document.querySelector(item.link);
            this.isActive = item.link;
            if (item.link === '#section-about-review') {
                window.dispatchEvent(
                    new CustomEvent('reviewsIsOpen', {
                        detail: true
                    })
                );
            }

            if (element) {
                const rect = element.getBoundingClientRect();
                const isFullyVisible =
                    rect.top >= 0 && rect.bottom <= window.innerHeight;

                if (!isFullyVisible) {
                    const offsetPosition = rect.top + window.scrollY - offset;
                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth'
                    });
                }
            }
        },

        setupObserver() {
            const options = {
                root: null,
                rootMargin: '-30% 0px -50% 0px',
                threshold: 0.1
            };

            this.observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        this.isActive = `#${entry.target.id}`;
                    }
                });
            }, options);

            document.querySelectorAll('.anchor-section').forEach((section) => {
                this.observer.observe(section);
            });
        }
    };
}
